<header class="header">
  <div class="container mx-auto">
    <div class="flex justify-between items-center">
      <div class="header__left">
        <button
          mat-icon-button
          class="navbar-toggle"
          [ngClass]="{ active: sidenavOpened }"
          (click)="onToggleSidenav()"
          *ngIf="(authService.isSignedIn$ | async) && mobileQuery.matches"
        >
          <mat-icon>{{ sidenavOpened ? 'arrow_back' : 'menu' }}</mat-icon>
        </button>
        <a class="header__logo text-decoration-none" [routerLink]="['/home']">
          <img src="assets/images/logo-small.png" class="px-3" alt="Logo" />
        </a>
      </div>
      <div class="header__right">
        <app-nav-list></app-nav-list>
        <app-profile-menu class="ml-4"></app-profile-menu>
      </div>
    </div>
  </div>
</header>
